import(/* webpackMode: "eager" */ "/app/src/app/forgot-password/page.tsx");
